import { createSelector } from 'reselect'
import createCachedSelector from 're-reselect'
import { suggestionList } from 'selectors/search_suggestions'
import { constructSearchQueryObject } from 'util/search'
import { selectTicketSearchOperatorValueMap } from './base'

const allQueries = suggestionList.map(suggestion => suggestion.searchQuery)
// Example regex with inbox query: /inbox:(\s*(["'])[^".]*\2?(?!\2\s)|\s*\S*(?!\S\s))/
// See more examples at getFilterMatchForQuery tests in src/components/ConversationList/Header/Search/__tests__/util.test.js
const operatorsPattern = `(${allQueries.join('|')})`
const valuePattern = `\\s*\\S*(?!\\S\\s)`
const valueInQuotesPattern = `\\s*(["'])[^"^'.]*\\4?(?!\\4\\s)`
export const filterRegex = `(${operatorsPattern}(${valueInQuotesPattern}|${valuePattern}))`
export const createRegexForFilter = filter =>
  new RegExp(`((${filter})(${valueInQuotesPattern}|${valuePattern}))`, 'g')

export const selectTicketSearchQueryObjectByQueryString = createCachedSelector(
  (_state, queryString) => queryString,
  selectTicketSearchOperatorValueMap,
  (queryString, operatorValueMap) => {
    return constructSearchQueryObject(queryString, operatorValueMap)
  }
)((_state, queryString) => queryString || 'unknown')

export function selectCurrentSubmittedTicketSearchQueryString(state) {
  const { submittedSearchQueryString } = state.search
  if (submittedSearchQueryString || submittedSearchQueryString === '') {
    return submittedSearchQueryString
  }
  return null
}

export const selectCurrentSubmittedTicketSearchQueryObject = createSelector(
  selectCurrentSubmittedTicketSearchQueryString,
  selectTicketSearchOperatorValueMap,
  (queryString, operatorValueMap) => {
    return constructSearchQueryObject(queryString, operatorValueMap)
  }
)

export const selectCurrentSubmittedTicketSearchFilterMatches = createSelector(
  selectCurrentSubmittedTicketSearchQueryString,
  submittedSearchQueryString => {
    if (!submittedSearchQueryString) return []
    return (
      Array.from(
        new Set(submittedSearchQueryString.match(new RegExp(filterRegex, 'g')))
      ) || []
    )
  }
)

export const selectSearchMailbox = state => state.search.searchMailbox
export const selectIsReloadingSubmittedSearchQuery = state =>
  state.search.isReloadingSubmittedSearchQuery

export const selectSearchEditorState = state => state.search.editorState
export const selectSearchEditor = state => state.search.editor
